import { render, staticRenderFns } from "./RatingComponent.vue?vue&type=template&id=d9bb680e&scoped=true&"
import script from "./RatingComponent.vue?vue&type=script&lang=ts&"
export * from "./RatingComponent.vue?vue&type=script&lang=ts&"
import style0 from "./RatingComponent.vue?vue&type=style&index=0&id=d9bb680e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bb680e",
  null
  
)

export default component.exports